module.exports = __webpack_public_path__ + "static/media/present-market-value.bb635240.svg";